export class AuthenticationController {

	constructor(AuthDao, BinMgrDao, $scope, GeneralSettingsDao, XRayUIModelSaver, $state, JFrogNotifications,
	            JFrogModal, $q, XRayUIPermissions, XrayPermissionsDao, $rootScope,XRayUIState) {
		this.GeneralSettingsDao = GeneralSettingsDao;
		this.binMgrDao = BinMgrDao;
		this.$rootScope = $rootScope;
		this.XrayPermissionsDao = XrayPermissionsDao;
		this.AuthDao = AuthDao;
		this.$scope = $scope;
        this.XRayUIState = XRayUIState;
		this.modal = JFrogModal;
		this.$state = $state;
		this.XRayUIPermissions = XRayUIPermissions;
		this.jFrogNotifications = JFrogNotifications;
		this.modelSaver = XRayUIModelSaver.createInstance(this, ['config']);
		this.$q = $q;
		$scope.$parent.Settings.showButtons = true;
		$scope.$parent.Settings.currentSubController = this;
		$scope.$parent.Settings.saveButtonText = 'Save';
		this.getInstances();
		//this.config = {};



		this.HELP_TOOLTIP = `The connected Artifactory instance through which users will be authenticated.
Selecting an authentication provider allows you to authenticate using LDAP/SAML and import users and groups from the  selected Artifactory instance. For more details, please <a href="https://www.jfrog.com/confluence/display/XRAY/Welcome+to+JFrog+Xray" target="_blank"> refer to the  User Guide. </a> `;
	}


	getConfig() {
		this.AuthDao.get_config().$promise.then((response) => {
			this.config = response;
			this.config.bin_mgr_id = _.find(this.relevantInstances, {'is_access': true});

			if (!this.config.bin_mgr_id || this.config.bin_mgr_id == '') {
				this.config.bin_mgr_id = {displayName: 'None'};
			}

			this.originalBinMgrId = _.cloneDeep(this.config.bin_mgr_id);
			this.modelSaver.save();
		});
	}

	getInstances() {

		this.binMgrDao.get().$promise.then(instances => {
			if (instances.length === 0) {
				this.AccessText = 'No Instances Configured';
				this.accessLevel = 'none';


			} else {
				let relevantInstances = this._pickFields(_.filter(instances, 'support_access'),
					['binMgrId', 'binMgrUrl', 'is_access']);
				_.forEach(relevantInstances, (value) => {
					value.displayName = value.binMgrId + ` [${value.binMgrUrl}]`;
				});

				if (relevantInstances.length > 0) {
					this.hasRelvantInstance = true;
					this.relevantInstances = relevantInstances;
					this.relevantInstances.unshift({displayName: 'None'});

					if (relevantInstances.length - 1 == instances.length) {
						this.AccessText = 'All Configured instances support Access';
						this.accessLevel = 'full';
					}

					if (relevantInstances.length - 1 < instances.length) {
						this.AccessText = 'Not All instances listed due to version compatibility ';
						this.accessLevel = 'partly';
					}
				} else {
					this.AccessText = `All of the connected Artifactory instances are below version 5.6 and cannot perform authentication for Xray.`;
					this.accessLevel = `none`;

				}
			}
			//console.log('This access text :', this.AccessText, this.accessLevel)
			this.getConfig();
		});
	}


	_pickFields(data, arrOfFields) {
		return _.map(data, _.partial(_.ary(_.pick, 2), _, arrOfFields));

	}

	save() {
		this.modelSaver.save();
		let text = '';
		let type = "set";
		let payload = _.cloneDeep(this.config);
		if (this.config.bin_mgr_id.displayName !== 'None') {
			payload.bin_mgr_id = this.config.bin_mgr_id.binMgrId;
		} else {
			payload.bin_mgr_id = '';
		}

		if (this.originalBinMgrId.binMgrId !== this.config.bin_mgr_id.binMgrId || this.originalautoLogin != this.config.auto_login_saml) {


			if (this.config.bin_mgr_id.displayName.toLowerCase() === 'none') {
				text = 'Removing your Artifactory authentication provider will affect user accessibility. Xray will not be able to authenticate users via LDAP or SAML, and will also not be able to import users and groups from Artifactory. Continue?';
				type = "delete";
			} else {

				if (this.originalBinMgrId.binMgrId !== this.config.bin_mgr_id.binMgrId) {
					text = 'Changing your Artifactory authentication provider may affect user accessibility. Continue?';
				} else {
					text = 'Changing your Artifactory SAML Configuration may affect user accessibility. Continue?';
				}
			}
			this.changeAuthInstance(text).then((modalResponse) => {
				let authPayload = {}
				if (type == 'set') {
					authPayload.bin_mgr_id = this.config.bin_mgr_id.binMgrId;
					authPayload.bin_mgr_url = this.config.bin_mgr_id.binMgrUrl;
					authPayload.auto_login_saml = this.config.auto_login_saml;
				}
				authPayload.xray_admin_user = modalResponse.adminUser;
				authPayload.xray_admin_password = modalResponse.adminPass;
				this.AuthDao.set_auth_provider({}, authPayload).$promise.then((authResponse) => {
					if (authResponse.status === 200 || authResponse.status === 201) {
						this.AuthDao.set_config({}, payload).$promise.then((response) => {
							this.modelSaver.save();
							if (response.status == 200) {
								// TODO: Need to check new permission obj at this point and then move to home
								this.XrayPermissionsDao.getCurrent().$promise.then((permissions) => {
									let obj = {permissions}
									this.XRayUIPermissions.setPermissionObj(obj);
									this.$rootScope.jfSidebar.refreshMenu();
									this.$state.go('home');
								});

							}
						});
					}
				});
			}).catch(() => {
				//console.log('aborted!')
			});
		} else {

			this.AuthDao.set_config({}, payload).$promise.then((response) => {
				this.modelSaver.save();
				if (response.status == 200) {
					this.XrayPermissionsDao.getCurrent().$promise.then((permissions) => {
						let obj = {permissions}
						this.XRayUIPermissions.setPermissionObj(obj);
						this.$rootScope.jfSidebar.refreshMenu();
						this.$state.go('home');
					});
					// TODO: Need to check new permission obj at this point and then move to home

				}
			});
		}
	}

	changeAuthInstance(text) {
		let defer = this.$q.defer();
		let modalScope = this.$scope.$new();
		modalScope.input = {};
		modalScope.text = text;
        if (text == "") {
			defer.resolve('empty');
		} else {

			this.modal.launchModal('change_auth_modal', modalScope).result.then(() => {
				defer.resolve(modalScope.input);
			}).catch(() => {
				defer.reject();
			});
		}

		return defer.promise;
	}


	cancel() {
		this.$state.go('home');
	}


	canSave() {
		return this.generalSettingsForm.$valid;
	}

}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/authentication/authentication.controller.js